export default __webpack_public_path__ + "cfa8d4ae1e0c89fbed2279f0364c7ce2.png";